export default __webpack_public_path__ + "90126223884723879981b0cf2b9a107f.svg";